export default __webpack_public_path__ + "static/heatmap-f2d29fba8e66f456d618f4c32061196b.png";